<div class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 backdrop-blur-md p-2 sm:p-4 animate-fade-in"
    (click)="onClose()">

    <div class="bg-white dark:bg-slate-900 rounded-2xl shadow-2xl w-full max-w-4xl max-h-[95vh] sm:max-h-[92vh] flex flex-col animate-scale-in overflow-hidden border border-white/20 dark:border-slate-800"
        (click)="$event.stopPropagation()">

        <div
            class="px-4 py-3 sm:px-6 sm:py-4 bg-white dark:bg-slate-900 border-b border-gray-100 dark:border-slate-800 flex flex-col sm:flex-row justify-between items-stretch sm:items-center gap-3 z-10">
            <div class="flex items-center gap-3">
                <div class="w-2 h-8 bg-yellow-400 rounded-full"></div>
                <h3 class="text-lg font-semibold text-gray-800 dark:text-white">ดูรายละเอียดใบแจ้งหนี้</h3>
            </div>

            <div class="flex items-center justify-between sm:justify-end gap-3 w-full sm:w-auto flex-wrap">
                <button (click)="print()"
                    class="group cursor-pointer flex items-center gap-2 px-3 py-1.5 sm:px-4 sm:py-2 rounded-lg bg-yellow-400 text-gray-900 text-xs sm:text-sm font-bold hover:bg-yellow-300 transition-all shadow-sm hover:shadow-md">
                    <span class="material-icons text-base sm:text-lg group-hover:scale-110 transition-transform">print</span>
                    พิมพ์ใบแจ้งหนี้
                </button>

                <button *ngIf="invoice.status === 3"
                    (click)="openCancelRequestPdf()"
                    class="group cursor-pointer flex items-center gap-2 px-3 py-1.5 sm:px-4 sm:py-2 rounded-lg bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-800 text-amber-800 dark:text-amber-300 text-xs sm:text-sm font-bold hover:bg-amber-100 dark:hover:bg-amber-900/40 transition-all">
                    <span class="material-icons text-base sm:text-lg">description</span>
                    พิมพ์เอกสารขอยกเลิก
                </button>

                <div class="h-6 w-px bg-gray-200 dark:bg-slate-700 mx-1 hidden sm:block"></div>

                <button (click)="onClose()"
                    class="p-2 rounded-full text-gray-400 dark:text-slate-500 hover:bg-gray-100 dark:hover:bg-slate-800 hover:text-gray-600 dark:hover:text-slate-300 transition-colors flex items-center justify-center"
                    title="ปิดหน้าต่าง">
                    <span class="material-icons text-xl">close</span>
                </button>
            </div>
        </div>

        <div class="flex-1 overflow-y-auto bg-gray-50/50 dark:bg-slate-900/50 p-3 sm:p-6 md:p-8 custom-scrollbar">

            <div *ngIf="isLoading" class="flex flex-col items-center justify-center min-h-[400px] space-y-4">
                <div
                    class="w-12 h-12 border-4 border-gray-100 dark:border-slate-800 border-t-yellow-400 rounded-full animate-spin">
                </div>
                <p class="text-gray-400 dark:text-slate-500 font-medium tracking-wide text-sm">กำลังโหลดข้อมูล...</p>
            </div>

            <div *ngIf="!isLoading && invoice"
                class="bg-white dark:bg-slate-800 shadow-sm border border-gray-100 dark:border-slate-700 mx-auto max-w-3xl min-h-[600px] p-4 sm:p-8 md:p-12 relative print:shadow-none print:border-none print:p-0 print:m-0 print:w-full print:max-w-none rounded-xl text-gray-900 dark:text-gray-100">

                <!-- Status Badge -->
                <div class="absolute top-4 right-4 sm:top-8 sm:right-8 pointer-events-none">
                    <span class="px-4 py-1.5 rounded-full text-xs font-bold tracking-widest border" [ngClass]="{
                          'bg-red-50 text-red-600 border-red-100 dark:bg-red-900/20 dark:text-red-400 dark:border-red-900/30': invoice.status === 3,
                          'bg-green-50 text-green-600 border-green-100 dark:bg-green-900/20 dark:text-green-400 dark:border-green-900/30': invoice.status === 2,
                          'bg-yellow-50 text-yellow-700 border-yellow-200 dark:bg-yellow-900/20 dark:text-yellow-400 dark:bg-yellow-900/30': invoice.status === 1,
                          'bg-gray-50 text-gray-400 border-gray-200 dark:bg-slate-700/50 dark:text-slate-400 dark:border-slate-700': invoice.status === 0
                      }">
                        {{ invoice.status === 2 ? 'ชำระแล้ว' : (invoice.status === 3 ? 'ยกเลิก' : (invoice.status === 1
                        ? 'รอชำระ' : 'รอดำเนินการ')) }}
                    </span>
                </div>

                <!-- Company Logo & Invoice Number Header -->
                <div class="flex flex-col sm:flex-row justify-between items-start gap-4 mb-10 sm:mb-16 mt-8 sm:mt-4">
                    <div class="flex items-start gap-5">
                        <div
                            class="w-14 h-14 bg-yellow-400 text-gray-900 flex items-center justify-center font-black text-2xl rounded-xl shadow-sm">
                            CP
                        </div>
                        <div>
                            <h1 class="text-xl font-bold text-gray-900 dark:text-white tracking-tight">PSS GROUP</h1>
                            <p class="text-sm text-gray-600 dark:text-slate-400 mt-1 font-medium">ใบแจ้งหนี้ / ใบกำกับภาษี</p>
                            <!-- <div class="mt-2 text-xs text-gray-400 dark:text-slate-500 space-y-0.5 font-light">
                                <p>123 ถนนลานจอดรถ ชั้น 5</p>
                                <p>เขตจตุจักร กรุงเทพฯ 10900</p>
                            </div> -->
                        </div>
                    </div>
                    <div class="text-left sm:text-right mt-1 w-full sm:w-auto">
                        <p class="text-[10px] font-bold text-gray-400 dark:text-slate-500 uppercase tracking-widest mb-1">
                            เลขที่เอกสาร</p>
                        <h2 class="text-xl font-mono font-bold text-gray-800 dark:text-slate-200">#{{ invoice.invoiceNo || '---' }}</h2>
                    </div>
                </div>

                <!-- Customer Details & Invoice Date Information -->
                <div class="grid grid-cols-12 gap-8 mb-12 sm:mb-16">
                    <div class="col-span-12 sm:col-span-7">
                        <div class="pl-4 border-l-2 border-yellow-400">
                            <h4 class="text-[10px] font-bold text-gray-400 dark:text-slate-500 uppercase tracking-widest mb-2">
                                ชื่อลูกค้า / ผู้ออกใบกำกับ
                            </h4>
                            <p class="text-lg font-bold text-gray-900 dark:text-white mb-1">{{ invoice.customerName }}</p>

                            <ng-container *ngIf="invoice.cityParkingAddress; else noAddress">
                                <p class="text-sm text-gray-500 dark:text-slate-400 leading-relaxed max-w-sm">
                                    <span *ngIf="invoice.cityParkingAddress.address">{{ invoice.cityParkingAddress.address }}</span>
                                    <span *ngIf="invoice.cityParkingAddress.subDistrict || invoice.cityParkingAddress.district">
                                        <br>
                                        {{ invoice.cityParkingAddress.subDistrict ? 'ต.' + invoice.cityParkingAddress.subDistrict : '' }}
                                        {{ invoice.cityParkingAddress.district ? 'อ.' + invoice.cityParkingAddress.district : '' }}
                                    </span>
                                    <span *ngIf="invoice.cityParkingAddress.province || invoice.cityParkingAddress.zipCode">
                                        <br>
                                        {{ invoice.cityParkingAddress.province ? 'จ.' + invoice.cityParkingAddress.province : '' }}
                                        {{ invoice.cityParkingAddress.zipCode }}
                                    </span>
                                </p>
                                <p class="text-xs text-gray-400 dark:text-slate-500 mt-2 font-mono" *ngIf="invoice.cityParkingAddress.taxId">
                                    <span class="font-medium">เลขผู้เสียภาษี:</span> {{ invoice.cityParkingAddress.taxId }}
                                </p>
                            </ng-container>
                            <ng-template #noAddress>
                                <p class="text-sm text-gray-300 dark:text-slate-600 italic">ไม่ระบุที่อยู่</p>
                            </ng-template>
                        </div>
                    </div>

                    <div class="col-span-12 sm:col-span-5 flex flex-col justify-center items-start sm:items-end space-y-4">
                        <div class="text-left sm:text-right">
                            <p class="text-[10px] font-bold text-gray-400 dark:text-slate-500 uppercase tracking-widest mb-1">
                                วันที่เอกสาร
                            </p>
                            <p class="text-sm font-semibold text-gray-700 dark:text-slate-300">
                                {{ formatDateDisplay(invoice.invoiceDate) }}
                            </p>
                        </div>
                        <div class="text-left sm:text-right">
                            <p class="text-[10px] font-bold text-gray-400 dark:text-slate-500 uppercase tracking-widest mb-1">
                                ครบกำหนดชำระ
                            </p>
                            <p class="text-sm font-semibold text-gray-700 dark:text-slate-300">
                                {{ formatDateDisplay(invoice.dueDate) }}
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Invoice Items Table -->
                <div class="mb-12 overflow-x-auto custom-scrollbar -mx-4 sm:mx-0">
                    <table class="w-full text-left border-collapse min-w-[580px] sm:min-w-0">
                        <thead>
                            <tr class="border-b border-gray-200 dark:border-slate-700">
                                <th class="py-3 text-[10px] font-bold uppercase tracking-widest text-gray-400 dark:text-slate-500 w-12 text-center">
                                    ลำดับ
                                </th>
                                <th class="py-3 text-[10px] font-bold uppercase tracking-widest text-gray-400 dark:text-slate-500">
                                    รายการ
                                </th>
                                <th class="py-3 text-[10px] font-bold uppercase tracking-widest text-gray-400 dark:text-slate-500 text-right w-24">
                                    จำนวน
                                </th>
                                <th class="py-3 text-[10px] font-bold uppercase tracking-widest text-gray-400 dark:text-slate-500 text-right w-32">
                                    ราคา/หน่วย
                                </th>
                                <th class="py-3 text-[10px] font-bold uppercase tracking-widest text-gray-400 dark:text-slate-500 text-right w-32">
                                    จำนวนเงิน
                                </th>
                            </tr>
                        </thead>
                        <tbody class="text-sm text-gray-600 dark:text-slate-400">
                            <tr *ngFor="let item of invoice.invoiceDetailResponses; let i = index"
                                class="group border-b border-gray-50 dark:border-slate-800/50 hover:bg-yellow-50/30 dark:hover:bg-slate-800 transition-colors">
                                <td class="py-4 text-center font-mono text-gray-400 dark:text-slate-500 text-xs">{{ i + 1 }}</td>
                                <td class="py-4 pr-4">
                                    <p class="font-semibold text-gray-800 dark:text-slate-200">{{ item.name }}</p>
                                    <p class="text-xs text-gray-400 dark:text-slate-500 mt-1 font-light" *ngIf="item.description">
                                        {{ item.description }}
                                    </p>
                                </td>
                                <td class="py-4 text-right font-mono">{{ item.quantity }}</td>
                                <td class="py-4 text-right font-mono">{{ item.fee | number:'1.2-2' }}</td>
                                <td class="py-4 text-right font-bold text-gray-800 dark:text-slate-200 font-mono">
                                    {{ (item.fee * item.quantity) | number:'1.2-2' }}
                                </td>
                            </tr>
                            <tr *ngIf="!invoice.invoiceDetailResponses || invoice.invoiceDetailResponses.length === 0">
                                <td colspan="5" class="py-12 text-center">
                                    <p class="text-gray-300 dark:text-slate-600 italic text-sm">ไม่พบรายการสินค้า</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Invoice Total Costs Summary -->
                <div class="flex justify-end mb-12 sm:mb-16 mt-4">
                    <div class="w-full sm:w-1/2 lg:w-5/12">
                        <div class="space-y-3 pb-4 border-b border-gray-100 dark:border-slate-700">
                            <div class="flex justify-between text-sm">
                                <span class="text-gray-500 dark:text-slate-400">รวมเป็นเงิน</span>
                                <span class="font-medium text-gray-700 dark:text-slate-300 font-mono">
                                    {{ calculatedSubtotal | number:'1.2-2' }}
                                </span>
                            </div>
                            <div class="flex justify-between text-sm">
                                <span class="text-gray-500 dark:text-slate-400">ภาษีมูลค่าเพิ่ม ({{ vatSetting.rateLabel() }}%)</span>
                                <span class="font-medium text-gray-700 dark:text-slate-300 font-mono">
                                    {{ calculatedVat | number:'1.2-2' }}
                                </span>
                            </div>
                        </div>

                        <div class="flex justify-between items-center mt-4 p-4 bg-yellow-200/50 dark:bg-yellow-900/20 rounded-lg border border-yellow-400 dark:border-yellow-900/50">
                            <span class="text-sm font-bold text-yellow-800 dark:text-yellow-400 uppercase tracking-wide">ยอดรวมสุทธิ</span>
                            <div class="text-right">
                                <span class="text-2xl font-black text-yellow-800 dark:text-yellow-400 tracking-tight">
                                    {{ calculatedNetTotal | number:'1.2-2' }}
                                </span>
                                <span class="text-xs font-bold text-yellow-600 dark:text-yellow-500 ml-1">บาท</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Payment channel (from selected bank account) -->
                <div *ngIf="invoice.bankAccountNumber || invoice.bankAccountHolderName"
                    class="mt-8 rounded-xl border border-slate-200 dark:border-slate-600 bg-slate-50/80 dark:bg-slate-900/40 p-4 text-sm text-slate-700 dark:text-slate-300">
                    <p class="font-bold text-slate-800 dark:text-slate-100 mb-2">ช่องทางการชำระค่าบริการ</p>
                    <p>ชื่อบัญชี {{ invoice.bankAccountHolderName || '-' }}</p>
                    <p>เลขที่บัญชี {{ invoice.bankAccountNumber || '-' }}</p>
                    <p>ธนาคาร {{ invoice.bankName || invoice.bankAccountName || '-' }}</p>
                    <p class="mt-2 text-xs text-slate-500 dark:text-slate-400">หากโอนชำระค่าบริการแล้วรบกวนแนบส่งสลิปให้ทราบด้วยนะคะ</p>
                    <p class="text-xs text-slate-500 dark:text-slate-400">ขอบคุณค่ะ</p>
                </div>

                <!-- Invoice Footer (Issuer details) -->
                <div class="mt-auto pt-6 border-t border-dashed border-gray-200 dark:border-slate-700">
                    <div class="text-xs">
                        <div class="flex flex-col justify-center items-center text-center text-gray-400 dark:text-slate-500 space-y-1">
                            <p>ผู้ออกเอกสาร: <span class="text-gray-600 dark:text-slate-400 font-medium">{{ invoice.createBy }}</span></p>
                            <p class="opacity-70">พิมพ์เมื่อ: {{ formatDateTimeDisplay(today) }}</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <!-- Sticky Bottom Bar -->
        <div
            class="p-4 bg-white dark:bg-slate-900 border-t border-gray-100 dark:border-slate-800 flex justify-between items-center gap-3 z-10 shadow-[0_-4px_20px_rgba(0,0,0,0.05)] dark:shadow-none">
            <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()"
                class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-slate-600 dark:text-slate-300 hover:border-amber-400 hover:text-amber-600 transition-colors inline-flex items-center gap-2 cursor-pointer">
                <span class="material-icons text-base">history</span>
                ดูประวัติ
            </button>
            <div class="flex justify-end ml-auto" *ngIf="invoice.status === 1">
                <button (click)="onCancelVerify()"
                    class="cursor-pointer w-full sm:w-auto px-6 py-3 rounded-xl bg-rose-50 dark:bg-rose-500/10 border border-rose-200 dark:border-rose-500/20 text-rose-600 dark:text-rose-400 text-sm font-bold hover:bg-rose-100 dark:hover:bg-rose-500/20 hover:text-rose-700 dark:hover:text-rose-300 hover:shadow-lg hover:shadow-rose-100/50 dark:hover:shadow-none transition-all flex items-center justify-center gap-2 group">
                    <span class="material-icons text-xl group-hover:scale-110 transition-transform">block</span>
                    ยกเลิกเอกสารใบนี้
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Cancel Confirmation Modal -->
<div *ngIf="showCancelModal"
    class="fixed inset-0 z-[60] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm animate-fade-in p-4"
    (click)="onCancelBackdropClick()">
    <div class="bg-white dark:bg-slate-900 rounded-xl shadow-2xl w-full max-w-lg animate-scale-in overflow-hidden border border-transparent dark:border-slate-800"
        (click)="$event.stopPropagation()">

        <div class="p-6" *ngIf="!showCancelPrintStep">
            <div class="text-center mb-5">
                <div
                    class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-rose-100 dark:bg-rose-900/30 mb-4">
                    <span class="material-icons text-rose-600 dark:text-rose-400 text-2xl">warning_amber</span>
                </div>
                <h3 class="text-lg font-bold text-gray-800 dark:text-white mb-2">ขอยกเลิกใบแจ้งหนี้</h3>
                <p class="text-sm text-gray-500 dark:text-slate-400">
                    ใบแจ้งหนี้
                    <span class="font-mono font-bold text-gray-700 dark:text-slate-300">#{{ invoice.invoiceNo }}</span>
                    <br>กรุณาระบุสาเหตุ / หมายเหตุก่อนยืนยัน
                </p>
            </div>

            <div class="mb-5 text-left">
                <label class="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">
                    สาเหตุ / หมายเหตุ <span class="text-rose-500">*</span>
                </label>
                <textarea
                    [(ngModel)]="cancelReason"
                    rows="4"
                    maxlength="1000"
                    placeholder="ระบุเหตุผลที่ต้องการยกเลิกใบแจ้งหนี้…"
                    class="w-full rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/60 px-3 py-2.5 text-sm text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-rose-300 dark:focus:ring-rose-700 resize-y min-h-[96px]"></textarea>
                <p class="mt-1 text-[11px] text-slate-400">อย่างน้อย 3 ตัวอักษ</p>
            </div>

            <div class="flex gap-3 justify-center">
                <button type="button" (click)="closeCancelModal()"
                    class="px-5 py-2.5 rounded-lg border border-gray-200 dark:border-slate-700 text-gray-600 dark:text-slate-300 text-sm font-bold hover:bg-gray-50 dark:hover:bg-slate-800 transition-colors bg-white dark:bg-slate-900 min-w-[100px]">
                    ปิด
                </button>
                <button type="button" (click)="confirmCancel()" [disabled]="!canConfirmCancel"
                    class="px-5 py-2.5 rounded-lg bg-rose-500 text-white text-sm font-bold hover:bg-rose-600 shadow-lg shadow-rose-200 dark:shadow-none transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 min-w-[140px]">
                    <span *ngIf="isProcessing"
                        class="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span>
                    <span>{{ isProcessing ? 'กำลังดำเนินการ...' : 'ยืนยันยกเลิก' }}</span>
                </button>
            </div>
        </div>

        <div class="p-6" *ngIf="showCancelPrintStep">
            <div class="text-center mb-5">
                <div
                    class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-emerald-100 dark:bg-emerald-900/30 mb-4">
                    <span class="material-icons text-emerald-600 dark:text-emerald-400 text-2xl">check_circle</span>
                </div>
                <h3 class="text-lg font-bold text-gray-800 dark:text-white mb-2">ยกเลิกเรียบร้อย</h3>
                <p class="text-sm text-gray-500 dark:text-slate-400 leading-relaxed">
                    พิมพ์ใบแจ้งหนี้และเอกสารขอยกเลิก<br>
                    เพื่อแนบเสนอแผนกบัญชีลงนาม
                </p>
            </div>

            <div class="flex flex-col gap-2.5 mb-5">
                <button type="button" (click)="openInvoicePdf()"
                    class="w-full px-4 py-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm font-bold hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors flex items-center justify-center gap-2">
                    <span class="material-icons text-sky-500">picture_as_pdf</span>
                    พิมพ์ใบแจ้งหนี้
                </button>
                <button type="button" (click)="openCancelRequestPdf()"
                    class="w-full px-4 py-3 rounded-xl border border-amber-200 dark:border-amber-800 bg-amber-50 dark:bg-amber-950/30 text-amber-800 dark:text-amber-300 text-sm font-bold hover:bg-amber-100 dark:hover:bg-amber-900/40 transition-colors flex items-center justify-center gap-2">
                    <span class="material-icons">description</span>
                    พิมพ์เอกสารขอยกเลิก
                </button>
            </div>

            <div class="flex justify-center">
                <button type="button" (click)="finishCancelFlow()"
                    class="px-6 py-2.5 rounded-lg bg-slate-800 dark:bg-slate-100 text-white dark:text-slate-900 text-sm font-bold hover:opacity-90 transition-opacity min-w-[120px]">
                    เสร็จสิ้น
                </button>
            </div>
        </div>
    </div>
</div>

<app-modal-invoice-pdf-viewer
    *ngIf="showPdfModal"
    [pdfSrc]="pdfSrc!"
    [invoiceNo]="invoice.invoiceNo"
    [modalTitle]="pdfModalTitle"
    [downloadFileName]="pdfDownloadName"
    (close)="showPdfModal = false">
</app-modal-invoice-pdf-viewer>

<app-pss-loading *ngIf="isProcessingPdf" text="กำลังโหลดไฟล์ PDF" detail="โปรดรอสักครู่ . . ."></app-pss-loading>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && id"
  [entityType]="activityEntityTypes.Invoice"
  [entityId]="id"
  title="ประวัติใบแจ้งหนี้"
  [subtitle]="'#' + id"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>

